package dev.lingvo.shared.screenshots.text

import dev.lingvo.shared.screenshots.doc.BrandKit
import dev.lingvo.shared.screenshots.doc.TypeRole

/** Keeps Latin brand glyphs first while routing native glyphs to explicit regional script faces. */
object DefaultFontResolver : FontResolver {
    /** The shared interface predates weight selection; its display default is 700 upright. */
    override fun stack(role: TypeRole, explicit: String?, brand: BrandKit, templateFamily: String?, script: Script, emoji: Boolean): FontStack =
        stack(role, explicit, brand, templateFamily, script, emoji, 700)

    /** Weight-aware callers can reject unsupported brand styles without altering the shared interface. */
    fun stack(role: TypeRole, explicit: String?, brand: BrandKit, templateFamily: String?, script: Script,
        emoji: Boolean, weight: Int, italic: Boolean = false): FontStack {
        val row = Scripts.rows.getValue(script)
        val names = buildList {
            fun candidate(name: String?) {
                if (name == null) return
                val family = FontCatalog.byName(name) ?: return
                if (weight in family.weights && (!italic || family.italic) &&
                    (script in family.scripts || Script.LATIN in family.scripts)) add(name)
            }
            if (role == TypeRole.MONO) add("IBM Plex Mono") else {
                candidate(explicit ?: if (role == TypeRole.DISPLAY) brand.displayFamily else brand.textFamily)
                candidate(templateFamily)
            }
            add(if (role == TypeRole.SERIF) row.serif else row.sans)
            add("Noto Sans")
            if (emoji) add("Noto Color Emoji")
        }.distinct()
        return FontStack(names, when (role) { TypeRole.SERIF -> "serif"; TypeRole.MONO -> "monospace"; else -> "sans-serif" })
    }
}
